export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-50 to-gray-100 pt-20 pb-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/522643aa3eefd18b29afb7e87b233f70/34b888998e0cae12311ffee1bb026b7e.png"
                alt="Cabadas Roofing LLC"
                className="h-12 w-auto mb-4"
              />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                CABADAS ROOFING LLC
              </h3>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-8">
              Florida&apos;s trusted roofing experts providing residential and commercial roof repairs, leak detection, storm damage restoration, and free inspections. Licensed, insured, and committed to protecting your home with quality craftsmanship.
            </p>

            {/* Newsletter */}
            <div>
              <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-3">
                Stay Updated
              </label>
              <form className="space-y-3">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full px-4 py-2.5 border-b-2 border-gray-300 bg-transparent focus:border-orange-600 focus:outline-none transition-colors text-sm"
                />
                <button
                  type="submit"
                  className="w-full md:w-auto px-8 py-2.5 border-2 border-orange-600 text-orange-600 rounded-full text-sm font-semibold hover:bg-orange-600 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-bold text-gray-900 mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('leak-detection')}
                  className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer"
                >
                  Leak Detection
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('storm-damage')}
                  className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer"
                >
                  Storm Damage
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer"
                >
                  Roof Repairs
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('inspections')}
                  className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer"
                >
                  Inspections
                </button>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Maintenance
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Emergency Service
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-base font-bold text-gray-900 mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Service Areas
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Careers
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base font-bold text-gray-900 mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:+18135429892" className="text-sm font-bold text-gray-900 hover:text-orange-600 transition-colors cursor-pointer">
                  (813) 542-9892
                </a>
              </li>
              <li>
                <a href="mailto:info@cabadasroofing.com" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                  info@cabadasroofing.com
                </a>
              </li>
              <li className="text-sm text-gray-600 leading-relaxed">
                123 Roofing Way<br />
                Tampa, FL 33601<br />
                United States
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-3 mt-6">
              <a
                href="#"
                className="w-9 h-9 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-600 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-600 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-600 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-600 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-base"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-300">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-600">
              © 2024 Cabadas Roofing LLC. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}